// export const getIsDataAvailable = () => {
//   const summaryUploadData = localStorage.getItem("summaryUploadData");
//   const summaryData = JSON.parse(summaryUploadData);

//   const checkAvailability = (key) => {
//     return summaryData && ["YES", "Yes"].includes(summaryData[key]);
//   };

//   return (
//     checkAvailability("Form 20") &&
//     checkAvailability("Electoral Roll") &&
//     checkAvailability("PS Village Mapping Data") &&
//     checkAvailability("Village Data")
//   );
// };

export const getIsDataAvailable = () => {
  const summaryUploadData = localStorage.getItem("summaryUploadData");
  // let summaryUploadData;
  // const isPolygonDataSet = localStorage.getItem("insideParliamentaryPolygonDataSet") === "true";
  // if (isPolygonDataSet) {
  //   summaryUploadData = localStorage.getItem("insideParliamentSummaryUploadData");
  // }
  // else
  // {
  //   summaryUploadData = localStorage.getItem("summaryUploadData");
  //   localStorage.setItem("insideParliamentaryPolygonDataSet", "false");
  // }

  // let summaryData = {};
  // try {
  //   summaryData = JSON.parse(summaryUploadData);
  // } catch (error) {
  //   console.error("Invalid JSON in summaryUploadData:", error);
  //   return false;
  // }

  let summaryData = {};
if (summaryUploadData) {
  try {
    summaryData = JSON.parse(summaryUploadData);
  } catch (error) {
    console.error("Invalid JSON in summaryUploadData:", error);
    return false;
  }
} else {
  console.warn("summaryUploadData is not available");
  return false;
}

  const checkAvailability = (key) => {
    return summaryData && ["YES", "Yes"].includes(summaryData[key]);
  };

  return (
    checkAvailability("Form 20") &&
    checkAvailability("Electoral Roll") &&
    checkAvailability("PS Village Mapping Data") &&
    checkAvailability("Village Data")
  );
};
